<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "@/assets/site/css/app.min.css";
import "@/assets/site/css/bootstrap.min.css";
// import "@/assets/site/css/bootstrap-dark.min.css"
// import "@/assets/site/css/app-dark.min.css"
// import "@/assets/site/css/icons.min.css"
// import "@/assets/site/fontawesome-free/css/all.min.css"

export default {
  name: "App",
};
</script>